import { useEffect } from "react";

const DEFAULT_META = {
  fr: {
    title: "Shotokan AAMC — Portail Phase 1",
    description:
      "Portail Shotokan AAMC — plateforme de démonstration et préparation Phase 1. Données [DÉMO], aucun backend sécurisé actif.",
  },
  en: {
    title: "Shotokan AAMC — Phase 1 Portal",
    description:
      "Shotokan AAMC portal — Phase 1 demonstration and preparation platform. [DEMO] data, no secure backend active.",
  },
};

/**
 * Met à jour title + meta description selon la locale (BT-045 branding).
 * @param {{ titleFr?: string, titleEn?: string, descriptionFr?: string, descriptionEn?: string }} pageMeta
 * @param {'fr'|'en'} locale
 */
export function usePageMeta(pageMeta, locale = "fr") {
  useEffect(() => {
    const isEn = locale === "en";
    const fallback = isEn ? DEFAULT_META.en : DEFAULT_META.fr;
    const title = isEn ? pageMeta?.titleEn || pageMeta?.titleFr : pageMeta?.titleFr || pageMeta?.titleEn;
    const description = isEn
      ? pageMeta?.descriptionEn || pageMeta?.descriptionFr
      : pageMeta?.descriptionFr || pageMeta?.descriptionEn;

    document.title = title || fallback.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || fallback.description);
    document.documentElement.lang = isEn ? "en" : "fr";

    return () => {
      document.title = fallback.title;
      meta.setAttribute("content", fallback.description);
    };
  }, [pageMeta, locale]);
}

export { DEFAULT_META };
